import Path from '@leverege/path';
export default {
  id: 'openApi.DefaultMutator',
  matches: {},
  mutate: (apiModel, cxt) => {
    const {
      molten,
      apiName
    } = cxt;
    const overrides = molten.getConfig(`openApiOverrides/${apiName}`);
    let nApiModel = apiModel;
    if (overrides) {
      Object.entries(overrides).forEach(([key, value]) => {
        nApiModel = Path(key).copy(nApiModel, value);
      });
    }
    return nApiModel;
  }
};